import SelectInput from "../../../components/input/SelectInput";
import Spinner from "../../../components/spinner/Spinner";
import ProjectDataCard from "../components/ProjectDataCard";
import Pagination from "../../../components/pagination/Pagination";

const Mobile = ({
  loading,
  selectedTab,
  count,
  selectedSortItem,
  projects,
  currentPage,
  sortItems,
  handleSelectedSortItem,
  handlePageChanged,
  handleArchive,
  handleFavourite,
  map,
}) => {
  return (
    <>
      {selectedTab === "list" ? (
        <>
          <div className="mt-4">
            <h4 className="text-start font-oswald lead-text">Projects Board</h4>

            <div className="d-flex text-10 align-items-center justify-content-between mb-5">
              <div className="">Showing {count} Results.</div>

              <div className="d-flex align-items-center w-50 justify-content-between">
                <p className="mb-0">Sort by:</p>
                <div className="w-70">
                  <SelectInput selectedItem={selectedSortItem}>
                    {sortItems.map((item) => (
                      <div
                        key={item.id}
                        onClick={() => handleSelectedSortItem(item.id)}
                        className="cursor-pointer select-input-item py-2 ps-4"
                      >
                        {item.value}
                      </div>
                    ))}
                  </SelectInput>
                </div>
              </div>
            </div>

            <div>
              {loading ? (
                <div className="m-auto">
                  <Spinner />
                </div>
              ) : (
                projects?.map((project) => (
                  <ProjectDataCard
                    key={project.id}
                    handleArchive={handleArchive}
                    handleFavourite={handleFavourite}
                    {...project}
                  />
                ))
              )}
            </div>
          </div>
          <div className="col-10 mx-auto">
            {loading ? (
              ""
            ) : (
              <Pagination
                totalRecords={count}
                pageLimit={10}
                pageNeighbours={0}
                onPageChanged={handlePageChanged}
                pageNumber={currentPage}
              />
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="col-12 mb-4" style={{ height: "90vh" }}>
            {map}
          </div>
        </div>
      )}
      {/* <div className="col-10 mx-auto">
        {loading ? (
          ""
        ) : (
          <Pagination
            totalRecords={count}
            pageLimit={10}
            pageNeighbours={0}
            onPageChanged={handlePageChanged}
            pageNumber={currentPage}
          />
        )}
      </div> */}
    </>
  );
};

export default Mobile;
